function createPlccApprovedModal() {
  document.body.insertAdjacentHTML('beforeend', `
  <div class="plcc-modal-dialog">
    <div class="modal-content">
        <svg class="plcc-modal-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" stroke="white" stroke-width="1px" fill="white">
        <path stroke="white" fill="white" d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path>
    </svg>
        <h4 class="modal-title">Congratulations on being approved for the Ashley Stewart Credit Card !</h4>
        <div class="modal-body">
            <p>For immediate usage with your new card , you must checkout within the next 15 minutes .You will receive your physical card in the mail within the next 10-15 days .</p>
            <p> Thank you for joining us , and happy shopping !</p>
        </div>
    </div>
</div>
  `);

  function handleModalClose(event) {
    // Check if the clicked element has the class 'plcc-modal-close'
    if (event.target.closest('.plcc-modal-close')) {
      // Find the modal dialog and remove it from the DOM if it exists
      const modalDialog = document.querySelector('.plcc-modal-dialog');
      if (modalDialog) {
        modalDialog.remove();
      }
      // Remove the event listener since the modal is closed
      document.body.removeEventListener('click', handleModalClose);
    }
  }

// Attach the event listener to the body
  document.body.addEventListener('click', handleModalClose);
}

